<span class="culture-impact-tag-text">{{ impactText }}</span>
